// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialMedia_root__qwXEN","list":"SocialMedia_list___x_8w","link":"SocialMedia_link__fxWhH","icon":"SocialMedia_icon__fKgY_"};